import { render } from "./ParticipantCard.vue?vue&type=template&id=688e8968&scoped=true"
import script from "./ParticipantCard.vue?vue&type=script&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&lang=js"

import "./ParticipantCard.vue?vue&type=style&index=0&id=688e8968&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688e8968"]])

export default __exports__